import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";

import api from "../services/api";
import { setAuthState, userLoggedOut } from "../redux/auth/authSlice";
import firebaseAuthService from "../services/firebase/firebaseAuthService";

// const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000/";
const API_BASE = "https://react9.myospaz.in/"
const SILENT_REFRESH_INTERVAL = 7 * 60 * 60 * 1000; // 7 hours (before the 8h token expiry)

export default function Auth({ children }) {
  const dispatch = useDispatch();
  const refreshTimerRef = useRef(null);

  // 🔄 Silent background token refresh
  const silentRefresh = async () => {
    try {
      const res = await axios.post(
        `${API_BASE}api/auth/refresh`,
        {},
        { withCredentials: true },
      );

      const newAccessToken = res.data?.accessToken;
      if (newAccessToken) {
        localStorage.setItem("accessToken", newAccessToken);
        console.log("🔄 Access token silently refreshed");
      }
    } catch (error) {
      console.warn("Silent refresh failed:", error.message);
      // Don't force logout here — the interceptor in api.js will handle it
      // on the next actual API call
    }
  };

  const startSilentRefreshTimer = () => {
    // Clear any existing timer
    if (refreshTimerRef.current) {
      clearInterval(refreshTimerRef.current);
    }

    refreshTimerRef.current = setInterval(silentRefresh, SILENT_REFRESH_INTERVAL);
  };

  const stopSilentRefreshTimer = () => {
    if (refreshTimerRef.current) {
      clearInterval(refreshTimerRef.current);
      refreshTimerRef.current = null;
    }
  };

  const bootstrapJwtAuth = async () => {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      dispatch(userLoggedOut());
      return;
    }

    try {
      const response = await api.get("/api/auth/me");
      dispatch(
        setAuthState({
          accessToken,
          user: response.data.user,
        }),
      );

      // Start silent refresh only after successful auth
      startSilentRefreshTimer();
    } catch (error) {
      dispatch(userLoggedOut());
    }
  };

  const checkFirebaseAuth = () => {
    firebaseAuthService.checkAuthStatus((user) => {
      if (user) {
        console.log(user.uid);
        console.log(user.email);
        console.log(user.emailVerified);
      } else {
        console.log("not logged in");
      }
    });
  };

  useEffect(() => {
    bootstrapJwtAuth();
    // checkFirebaseAuth();

    return () => stopSilentRefreshTimer();
  }, []);

  return <>{children}</>;
}
